(function () {
  function setup(container) {
    if (container._topbarCleanup) container._topbarCleanup();

    var slides = Array.from(container.querySelectorAll('[data-hanso-topbar-slide]'));
    if (slides.length < 2) return;

    var current = 0;
    var timer;
    var interval = Math.max(3000, Number(container.dataset.interval) || 8000);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function activate(next) {
      if (next === current) return;
      var outgoing = slides[current];
      var incoming = slides[next];
      var gsap = window.gsap;
      outgoing.style.pointerEvents = 'none';
      incoming.style.pointerEvents = 'auto';
      if (gsap) {
        gsap.killTweensOf([outgoing, incoming]);
        gsap.set(incoming, { visibility: 'visible', y: 14, autoAlpha: 0 });
        gsap.to(outgoing, { y: -14, autoAlpha: 0, duration: 0.3, ease: 'power2.in', onComplete: function () {
          outgoing.style.visibility = 'hidden';
        } });
        gsap.to(incoming, { y: 0, autoAlpha: 1, duration: 0.35, delay: 0.2, ease: 'power2.out' });
      } else {
        outgoing.style.visibility = 'hidden';
        outgoing.style.opacity = '0';
        incoming.style.visibility = 'visible';
        incoming.style.opacity = '1';
      }
      outgoing.setAttribute('aria-hidden', 'true');
      incoming.removeAttribute('aria-hidden');
      current = next;
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (reducedMotion.matches || document.hidden || container.matches(':hover, :focus-within')) return;
      timer = setInterval(function () { activate((current + 1) % slides.length); }, interval);
    }

    slides.forEach(function (slide, index) {
      if (index) slide.setAttribute('aria-hidden', 'true');
    });
    container.addEventListener('mouseenter', stop);
    container.addEventListener('mouseleave', start);
    container.addEventListener('focusin', stop);
    container.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', start);
    container._topbarCleanup = function () {
      stop();
      container.removeEventListener('mouseenter', stop);
      container.removeEventListener('mouseleave', start);
      container.removeEventListener('focusin', stop);
      container.removeEventListener('focusout', start);
      document.removeEventListener('visibilitychange', start);
      reducedMotion.removeEventListener('change', start);
    };
    start();
  }

  function initialize(root) {
    root.querySelectorAll('[data-hanso-topbar-messages]').forEach(setup);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
